import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimaryButtonComponent } from './components/atoms/primary-button/primary-button.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { InputComponent } from './components/atoms/input/input.component';
import { CircleComponent } from './components/atoms/circle/circle.component';
import { StepComponent } from './components/atoms/step/step.component';
import { StepsComponent } from './components/molecules/steps/steps.component';
import { ParagraphComponent } from './components/atoms/paragraph/paragraph.component';
import { AnchorComponent } from './components/atoms/anchor/anchor.component';
import { RouterModule } from '@angular/router';
import { LabelComponent } from './components/atoms/label/label.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EpsonPoweredComponent } from './components/atoms/epson-powered/epson-powered.component';
import { SelectComponent } from './components/atoms/select/select.component';
import { HeaderComponent } from './components/molecules/header/header.component';
import { IconButtonComponent } from './components/atoms/icon-button/icon-button.component';
import { MainHeaderComponent } from './components/molecules/main-header/main-header.component';
import { DialogModalComponent } from './components/molecules/dialog-modal/dialog-modal.component';
import { ExpansionPanelComponent } from './components/molecules/expansion-panel/expansion-panel.component';
import { CheckboxComponent } from './components/molecules/checkbox/checkbox.component';
import { SidemenuItemComponent } from './components/atoms/sidemenu-item/sidemenu-item.component';
import { LabelPromptButtonComponent } from './components/molecules/label-prompt-button/label-prompt-button.component';
import { RoundedImageComponent } from './components/atoms/rounded-image/rounded-image.component';
import { StickerIconComponent } from './components/atoms/sticker-icon/sticker-icon.component';
import { IconClickComponent } from './components/atoms/icon-click/icon-click.component';
import { SecondaryButtonComponent } from './components/atoms/secondary-button/secondary-button.component';
import { ChipComponent } from './components/atoms/chip/chip.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MonthExpansionPanelComponent } from './components/molecules/month-expansion-panel/month-expansion-panel.component';
import { MatRippleModule } from '@angular/material/core';
import { FilterDateModalComponent } from './components/molecules/filter-date-modal/filter-date-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ThrottleClickDirective } from './directives/throttle-click/throttle-click.directive';
import { SnackBarComponent } from './components/molecules/snackbar/snackbar.component';
import { ActivityCardComponent } from './components/molecules/activity-card/activity-card.component';
import { HorizontalSeparatorComponent } from './components/atoms/horizontal-separator/horizontal-separator.component';
import { TranslocoModule } from '@ngneat/transloco';
import { CouponCardComponent } from './components/molecules/coupon-card/coupon-card.component';
import { SidenavContentComponent } from './components/organisms/sidenav-content/sidenav-content.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HeaderContentFooterComponent } from './components/templates/header-content-footer/header-content-footer.component';
import { SideMenuComponent } from './components/molecules/side-menu/side-menu.component';
import { UserHeaderComponent } from './components/organisms/user-header/user-header.component';
import { DesktopHeaderComponent } from './components/organisms/desktop-header/desktop-header.component';
import { NavigationBarComponent } from './components/molecules/navigation-bar/navigation-bar.component';
import { BusinessInfoPopupComponent } from './components/organisms/business-info-popup/business-info-popup.component';
import { FeedComponent } from './components/organisms/feed/feed.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NotesInfoPopupComponent } from './components/organisms/notes-info-popup/notes-info-popup.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AccountSettingsComponent } from './components/organisms/account-settings/account-settings.component';
import { EditAccountComponent } from './components/organisms/edit-account/edit-account.component';
import { EditSettingsComponent } from './components/organisms/edit-settings/edit-settings.component';
import { FilterAreaComponent } from './components/organisms/filter-area/filter-area.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CouponStatusPopupComponent } from './components/organisms/coupon-status-popup/coupon-status-popup.component';
import { MatMenuModule } from '@angular/material/menu';
import { ProfileMenuComponent } from './components/molecules/profile-menu/profile-menu.component';
import { NgxMaskModule } from 'ngx-mask';
import { MatChipsModule } from '@angular/material/chips';
import { CouponStatusComponent } from './components/organisms/coupon-status/coupon-status.component';
import { RegionFilterModalComponent } from './components/molecules/region-filter-modal/region-filter-modal.component';
import { BusinessCardComponent } from './components/molecules/business-card/business-card.component';
import { BusinessesFeedComponent } from './components/organisms/businesses-feed/businesses-feed.component';
import { OnboardingComponent } from './components/organisms/onboarding/onboarding.component';
import { FlagPipe } from './pipes/flag/flag.pipe';
import { SideMenuDesktopComponent } from './components/organisms/side-menu-desktop/side-menu-desktop.component';
import { HeaderBarDesktopComponent } from './components/organisms/header-bar-desktop/header-bar-desktop.component';
import { QuickMenuItemComponent } from './components/atoms/quick-menu-item/quick-menu-item.component';
import { LnrOktaCallbackComponent } from './components/organisms/lnr-okta-callback/lnr-okta-callback.component';
import { FullPageLoadingModule } from '../full-page-loading/full-page-loading.module';
import { FileUploadComponent } from './components/molecules/file-upload/file-upload.component';
import { UploadMigrationComponent } from './components/organisms/upload-migration/upload-migration.component';
import { UploadQueueHeadComponent } from './components/organisms/upload-queue-head/upload-queue-head.component';
import { LnrDatePipe } from './pipes/lnr-date/lnr-date.pipe';
import { CustomerDetailComponent } from './components/organisms/customer-detail/customer-detail.component';
import { CustomerDetailSelectorComponent } from './components/molecules/customer-detail-selector/customer-detail-selector.component';
import { CustomerSummaryComponent } from './components/organisms/customer-summary/customer-summary.component';
import { CustomerPointsComponent } from './components/organisms/customer-points/customer-points.component';
import { CustomerPrintersComponent } from './components/organisms/customer-printers/customer-printers.component';
import { BusinessBasicDetailsComponent } from './components/molecules/business-basic-details/business-basic-details.component';
import { EditBusinessModalComponent } from './components/molecules/edit-business-modal/edit-business-modal.component';
import { RewardsComponent } from './components/organisms/rewards/rewards.component';
import { RewardCardComponent } from './components/molecules/reward-card/reward-card.component';
import { RepresentativeListComponent } from './components/organisms/representative-list/representative-list.component';
import { RepresentativeItemComponent } from './components/molecules/representative-item/representative-item.component';
import { PhotoNameComponent } from './components/molecules/photo-name/photo-name.component';
import { RepresentativeInviteListComponent } from './components/organisms/representative-invite-list/representative-invite-list.component';
import { PointsSummaryComponent } from './components/molecules/points-summary/points-summary.component';
import { CreateReportModalComponent } from './components/molecules/create-report-modal/create-report-modal.component';
import { TimelineComponent } from './components/organisms/timeline/timeline.component';
import { TransactionCardComponent } from './components/molecules/transaction-card/transaction-card.component';
import { TransactionCardExpandedComponent } from './components/molecules/transaction-card-expanded/transaction-card-expanded.component';
import { UserGuard } from './guards/user/userGuard';
import { OktaCallbackGuard } from './guards/okta-callback/okta-callback.guard';
import { LogoutGuard } from './guards/logout/logout.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';
import { PointTransactionModalComponent } from './components/organisms/point-transaction-modal/point-transaction-modal.component';
import { EmptyFeedComponent } from './components/molecules/empty-feed/empty-feed.component';
import { CustomerDetailCouponsComponent } from './components/organisms/customer-detail-coupons/customer-detail-coupons.component';
import { UpdateVipModalComponent } from './components/organisms/update-vip-modal/update-vip-modal.component';
import { CouponCardVipComponent } from './components/molecules/coupon-card-vip/coupon-card-vip.component';
import { BusinessEquipmentFormComponent } from './components/molecules/business-equipment-form/business-equipment-form.component';
import { AdminEditDataComponent } from './components/molecules/admin-edit-data/admin-edit-data.component';
import { LoadingComponent } from './components/molecules/loading/loading.component';
import { ImageUploadV1Component } from './components/molecules/image-upload-v1/image-upload-v1.component';
import { ImageUploadModalComponent } from './components/molecules/image-upload-modal/image-upload-modal.component';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LySliderModule } from '@alyle/ui/slider';
import { ImageUploadComponent } from './components/molecules/image-upload/image-upload.component';
import { SearchComponent } from './components/molecules/search/search.component';
import { NbIconModule } from '@nebular/theme';
import { DialogModalSelectComponent } from './components/molecules/dialog-modal-select/dialog-modal-select.component';
import { MultiSelectComponent } from './components/atoms/multi-select/multi-select.component';
import { DownloadReportsComponent } from './components/organisms/download-reports/download-reports.component';
import { StatusComponent } from './components/atoms/status/status.component';
import { RadioComponent } from './components/molecules/radio/radio.component';
import { DownloadReportModalComponent } from './components/molecules/download-report-modal/download-report-modal.component';
import { DownloadReportItemComponent } from './components/molecules/download-report-item/download-report-item.component';
import { DateRangePickerComponent } from './components/molecules/date-range-picker/date-range-picker.component';
import { MaxRangeDirective } from './directives/datepicker/date-picker.directive';
import { MaxRangeSelectionStrategy } from './directives/datepicker/max-range-strategy';
import { FilterContainerComponent } from './components/organisms/filter-container/filter-container.component';
import { BusinessEquipmentTupleComponent } from './components/molecules/business-equipment-tuple/business-equipment-tuple.component';
import { ProductFormComponent } from './components/organisms/product-form/product-form.component';
import { AddEditProductComponent } from './components/organisms/add-edit-product/add-edit-product.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ProductStepperComponent } from './components/molecules/product-stepper/product-stepper.component';
import { ProductStepDirective } from './directives/product-step/product-step.directive';
import { ProductImageUploadComponent } from './components/molecules/product-image-upload/product-image-upload.component';
import { ProductSummaryComponent } from './components/molecules/product-summary/product-summary.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SlideToggleComponent } from './components/atoms/slide-toggle/slide-toggle.component';
import { ProductCreatedModalComponent } from './components/molecules/product-created-modal/product-created-modal.component';
import { AddEditRewardComponent } from './components/organisms/add-edit-reward/add-edit-reward.component';
import { VipCheckboxGroupComponent } from './components/organisms/vip-checkbox-group/vip-checkbox-group.component';
import { RewardDetailsFormComponent } from './components/molecules/reward-details-form/reward-details-form.component';
import { RegionTargetFormComponent } from './components/molecules/region-target-form/region-target-form.component';
import { RewardOverviewFormComponent } from './components/molecules/reward-overview-form/reward-overview-form.component';
import { CheckboxAccordionComponent } from './components/molecules/checkbox-accordion/checkbox-accordion.component';
import { RewardCreatedModalComponent } from './components/molecules/reward-created-modal/reward-created-modal.component';
import { DeleteRewardModalComponent } from './components/molecules/delete-reward-modal/delete-reward-modal.component';
import { SearchSelectComponent } from './components/atoms/search-select/search-select.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RewardActionsComponent } from './components/molecules/reward-actions/reward-actions.component';
import { RegionSelectorComponent } from './components/molecules/region-selector/region-selector.component';
import { NumberManualIncrementComponent } from './components/atoms/number-manual-increment/number-manual-increment.component';
import { RewardInfoComponent } from './components/molecules/reward-info/reward-info.component';
import { RewardInfoModalComponent } from './components/molecules/reward-info-modal/reward-info-modal.component';
import { CouponCardVipCustomerComponent } from './components/molecules/coupon-card-vip-customer/coupon-card-vip-customer.component';
import { ProductCouponVipContentComponent } from './components/organisms/product-coupon-vip-content/product-coupon-vip-content.component';
import { CountrySelectorComponent } from './components/molecules/country-selector/country-selector.component';
import { EditVipSettingsComponent } from './components/organisms/edit-vip-settings/edit-vip-settings.component';
import { DeleteVipModalComponent } from './components/molecules/delete-vip-modal/delete-vip-modal.component';
import { AddVipModalComponent } from './components/molecules/add-vip-modal/add-vip-modal.component';
import { SystemSettingsComponent } from './components/organisms/system-settings/system-settings.component';
import { DateTabSelectorComponent } from './components/molecules/date-tab-selector/date-tab-selector.component';
import { BusinessUnificationComponent } from './components/organisms/business-unification/business-unification.component';
import { SettingsScheduleModalComponent } from './components/molecules/settings-schedule-modal/settings-schedule-modal.component';
import { MatCardModule } from '@angular/material/card';
import { MultiSelectFilterComponent } from './components/organisms/multiselect-filter/multiselect-filter.component';
import { PortPointsExecutionHeadComponent } from './components/organisms/port-points-execution-head/port-points-execution-head.component';
import { BusinessUnificationDetailsModalComponent } from './components/molecules/business-unification-details-modal/business-unification-details-modal.component';
import { MatDividerModule } from '@angular/material/divider';
import { BusinessUnificationStatusComponent } from './components/atoms/business-unification-status/business-unification-status.component';
import { NewBusinessUnificationModalComponent } from './components/molecules/new-business-unification-modal/new-business-unification-modal.component';
import { BusinessVipDetailsComponent } from './components/molecules/business-vip-details/business-vip-details.component';

@NgModule({
  declarations: [
    PrimaryButtonComponent,
    IconButtonComponent,
    InputComponent,
    CircleComponent,
    StepComponent,
    StepsComponent,
    ParagraphComponent,
    AnchorComponent,
    LabelComponent,
    EpsonPoweredComponent,
    ImageUploadV1Component,
    FileUploadComponent,
    SelectComponent,
    HeaderComponent,
    MainHeaderComponent,
    DialogModalComponent,
    ExpansionPanelComponent,
    CheckboxComponent,
    SidemenuItemComponent,
    LabelPromptButtonComponent,
    RoundedImageComponent,
    StickerIconComponent,
    IconClickComponent,
    SecondaryButtonComponent,
    ChipComponent,
    MonthExpansionPanelComponent,
    FilterDateModalComponent,
    ThrottleClickDirective,
    MaxRangeDirective,
    SnackBarComponent,
    ActivityCardComponent,
    HorizontalSeparatorComponent,
    CouponCardComponent,
    SidenavContentComponent,
    HeaderContentFooterComponent,
    SideMenuComponent,
    UserHeaderComponent,
    DesktopHeaderComponent,
    NavigationBarComponent,
    BusinessInfoPopupComponent,
    FeedComponent,
    NotesInfoPopupComponent,
    AccountSettingsComponent,
    BusinessUnificationComponent,
    SystemSettingsComponent,
    EditAccountComponent,
    EditSettingsComponent,
    FilterAreaComponent,
    CouponStatusComponent,
    CouponStatusPopupComponent,
    ProfileMenuComponent,
    RegionFilterModalComponent,
    BusinessCardComponent,
    BusinessesFeedComponent,
    OnboardingComponent,
    FlagPipe,
    SideMenuDesktopComponent,
    HeaderBarDesktopComponent,
    QuickMenuItemComponent,
    LnrOktaCallbackComponent,
    UploadMigrationComponent,
    UploadQueueHeadComponent,
    LnrDatePipe,
    CustomerDetailComponent,
    CustomerDetailSelectorComponent,
    CustomerSummaryComponent,
    CustomerPointsComponent,
    CustomerPrintersComponent,
    BusinessBasicDetailsComponent,
    BusinessVipDetailsComponent,
    EditBusinessModalComponent,
    BusinessUnificationDetailsModalComponent,
    NewBusinessUnificationModalComponent,
    RewardsComponent,
    RewardCardComponent,
    RepresentativeListComponent,
    RepresentativeItemComponent,
    PhotoNameComponent,
    RepresentativeInviteListComponent,
    PointsSummaryComponent,
    CreateReportModalComponent,
    TimelineComponent,
    TransactionCardComponent,
    TransactionCardExpandedComponent,
    PointTransactionModalComponent,
    EmptyFeedComponent,
    CustomerDetailCouponsComponent,
    UpdateVipModalComponent,
    CouponCardVipComponent,
    BusinessEquipmentFormComponent,
    AdminEditDataComponent,
    LoadingComponent,
    ImageUploadModalComponent,
    ImageUploadComponent,
    SearchComponent,
    DialogModalSelectComponent,
    MultiSelectComponent,
    DownloadReportsComponent,
    StatusComponent,
    BusinessUnificationStatusComponent,
    RadioComponent,
    DownloadReportModalComponent,
    DownloadReportItemComponent,
    DateRangePickerComponent,
    FilterContainerComponent,
    MultiSelectFilterComponent,
    BusinessEquipmentTupleComponent,
    ProductFormComponent,
    AddEditProductComponent,
    ProductStepperComponent,
    ProductStepDirective,
    ProductImageUploadComponent,
    ProductSummaryComponent,
    SlideToggleComponent,
    ProductCreatedModalComponent,
    AddEditRewardComponent,
    VipCheckboxGroupComponent,
    RewardDetailsFormComponent,
    RegionTargetFormComponent,
    RewardOverviewFormComponent,
    CheckboxAccordionComponent,
    RewardCreatedModalComponent,
    DeleteRewardModalComponent,
    SearchSelectComponent,
    RewardActionsComponent,
    RegionSelectorComponent,
    NumberManualIncrementComponent,
    RewardInfoComponent,
    RewardInfoModalComponent,
    CouponCardVipCustomerComponent,
    ProductCouponVipContentComponent,
    CountrySelectorComponent,
    EditVipSettingsComponent,
    DeleteVipModalComponent,
    AddVipModalComponent,
    DateTabSelectorComponent,
    SettingsScheduleModalComponent,
    PortPointsExecutionHeadComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    ImageCropperModule,
    MatDatepickerModule,
    MatTooltipModule,
    TranslocoModule,
    MatSidenavModule,
    InfiniteScrollModule,
    MatTabsModule,
    CarouselModule,
    MatRippleModule,
    MatMenuModule,
    NgxMaskModule.forRoot(),
    MatChipsModule,
    FullPageLoadingModule,
    MatTableModule,
    LyImageCropperModule,
    LySliderModule,
    NbIconModule,
    MatRadioModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatCardModule,
  ],
  exports: [
    PrimaryButtonComponent,
    IconButtonComponent,
    InputComponent,
    CircleComponent,
    ParagraphComponent,
    StepComponent,
    StepsComponent,
    AnchorComponent,
    LabelComponent,
    EpsonPoweredComponent,
    ImageUploadV1Component,
    FileUploadComponent,
    SelectComponent,
    HeaderComponent,
    MainHeaderComponent,
    DialogModalComponent,
    ExpansionPanelComponent,
    RoundedImageComponent,
    LabelPromptButtonComponent,
    StickerIconComponent,
    IconClickComponent,
    SecondaryButtonComponent,
    ChipComponent,
    MonthExpansionPanelComponent,
    CouponCardComponent,
    SidenavContentComponent,
    HeaderContentFooterComponent,
    SideMenuComponent,
    SidemenuItemComponent,
    UserHeaderComponent,
    DesktopHeaderComponent,
    NavigationBarComponent,
    BusinessInfoPopupComponent,
    FeedComponent,
    AccountSettingsComponent,
    BusinessUnificationComponent,
    SystemSettingsComponent,
    FilterAreaComponent,
    CouponStatusComponent,
    CouponStatusPopupComponent,
    BusinessesFeedComponent,
    OnboardingComponent,
    HeaderBarDesktopComponent,
    QuickMenuItemComponent,
    LnrOktaCallbackComponent,
    UploadMigrationComponent,
    HeaderBarDesktopComponent,
    CustomerDetailComponent,
    CustomerDetailSelectorComponent,
    CustomerSummaryComponent,
    CustomerPointsComponent,
    CustomerPrintersComponent,
    BusinessBasicDetailsComponent,
    BusinessVipDetailsComponent,
    RewardsComponent,
    RepresentativeListComponent,
    RepresentativeItemComponent,
    PhotoNameComponent,
    PointTransactionModalComponent,
    RepresentativeInviteListComponent,
    EmptyFeedComponent,
    UpdateVipModalComponent,
    BusinessEquipmentFormComponent,
    AdminEditDataComponent,
    ImageUploadModalComponent,
    ImageUploadComponent,
    SearchComponent,
    DialogModalSelectComponent,
    MultiSelectComponent,
    DownloadReportsComponent,
    StatusComponent,
    BusinessUnificationStatusComponent,
    RadioComponent,
    DownloadReportModalComponent,
    DateRangePickerComponent,
    FilterContainerComponent,
    MultiSelectFilterComponent,
    ProductFormComponent,
    AddEditProductComponent,
    MatStepperModule,
    SlideToggleComponent,
    AddEditRewardComponent,
    SearchSelectComponent,
    RewardActionsComponent,
    NumberManualIncrementComponent,
    ProductCouponVipContentComponent,
    EditVipSettingsComponent,
  ],
  providers: [
    UserGuard,
    OktaCallbackGuard,
    LogoutGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    MaxRangeSelectionStrategy,
  ],
})
/**
 * Shared module that enables reuse of artifacts, such as components
 */
export class SharedModule {}
